/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DigitalBillMetadataDto } from './DigitalBillMetadataDto';
import {
    DigitalBillMetadataDtoFromJSON,
    DigitalBillMetadataDtoFromJSONTyped,
    DigitalBillMetadataDtoToJSON,
} from './DigitalBillMetadataDto';

/**
 * 
 * @export
 * @interface CreatedDigitalBillDto
 */
export interface CreatedDigitalBillDto {
    /**
     * 
     * @type {string}
     * @memberof CreatedDigitalBillDto
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedDigitalBillDto
     */
    primaryReference: string;
    /**
     * 
     * @type {number}
     * @memberof CreatedDigitalBillDto
     */
    sum: number;
    /**
     * 
     * @type {string}
     * @memberof CreatedDigitalBillDto
     */
    updated: string;
    /**
     * 
     * @type {DigitalBillMetadataDto}
     * @memberof CreatedDigitalBillDto
     */
    metadata?: DigitalBillMetadataDto;
    /**
     * 
     * @type {number}
     * @memberof CreatedDigitalBillDto
     */
    sumExTips: number;
}

/**
 * Check if a given object implements the CreatedDigitalBillDto interface.
 */
export function instanceOfCreatedDigitalBillDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reference" in value;
    isInstance = isInstance && "primaryReference" in value;
    isInstance = isInstance && "sum" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "sumExTips" in value;

    return isInstance;
}

export function CreatedDigitalBillDtoFromJSON(json: any): CreatedDigitalBillDto {
    return CreatedDigitalBillDtoFromJSONTyped(json, false);
}

export function CreatedDigitalBillDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedDigitalBillDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reference': json['reference'],
        'primaryReference': json['primaryReference'],
        'sum': json['sum'],
        'updated': json['updated'],
        'metadata': !exists(json, 'metadata') ? undefined : DigitalBillMetadataDtoFromJSON(json['metadata']),
        'sumExTips': json['sumExTips'],
    };
}

export function CreatedDigitalBillDtoToJSON(value?: CreatedDigitalBillDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reference': value.reference,
        'primaryReference': value.primaryReference,
        'sum': value.sum,
        'updated': value.updated,
        'metadata': DigitalBillMetadataDtoToJSON(value.metadata),
        'sumExTips': value.sumExTips,
    };
}

